/** @format */

import updateServiceValue from './update';

export default {
  updateServiceValue
};
